
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import { Attachment } from '@/types';

moment.locale('it');

@Component
export default class AttachmentDate extends Vue {
  @Prop(Object) readonly attachment!: Attachment

  get dateLong(): string {
    return `${moment(this.attachment.createdAt).format('L')} ore ${moment(this.attachment.createdAt).format('LT')}`;
  }
}
